import React from 'react';
import SideMenuSubItem from './sideMenuSubItem';
import { Link } from 'react-router';
import { connect } from 'react-redux';
import { Permissioned } from 'react-permissions';
import Util from '../../util/util';


class SideMenuItem extends React.Component {

    constructor(props, context) {
        super(props, context);
        this.state = {
            subMenuVisible : false
        };
        this.onClickMenu =  this.onClickMenu.bind(this);
       
    }

    onClickMenu()
    {
        let val = !(this.state.subMenuVisible)
        this.setState({subMenuVisible : val});
    }

    render() {
        //TODO move menu rebuild to componentWillReceiveProps
        this.rebuildSubMenuItems(this.props);
        return (
            <li id={`${this.props.menuItem.key}-menu-item`} role="presentation" className="has-submenu sidebar-menu-item" >
                <Link to={this.menuItem.route ? this.menuItem.route.path : null} 
                        onClick={this.onClickMenu}  
                        activeClassName={this.menuItem.route ? "active-sidebar-item" : ""}>

                    <i className={this.menuItem.iconClass || "ion ion-ios-circle-filled" }></i> {this.menuItem.title}</Link>
                <ul className={"second-level"} style={{visibility : this.state.subMenuVisible ? 'visible' : 'collapse'}}>
                    {this.subMenus.length > 0 && this.state.subMenuVisible && this.subMenus}
                </ul>
            </li>
        );
    }

    rebuildSubMenuItems(props){
        let menuItem = props.menuItem;
        let subMenus = [];
        if (menuItem.subMenus) {
            subMenus = menuItem.subMenus.map((subMenu) => {
                return (
                    <SideMenuSubItem id={`${subMenu.key}-submenu-item`} location={props.location} allowedPermissions={subMenu.permissions} key={subMenu.key} subMenuItem={subMenu} />
                );
            });
        }
         this.menuItem = menuItem;
        this.subMenus = subMenus;
    }
}

export default connect(Util.defaultMapStateToProps)(Permissioned(SideMenuItem));


// WEBPACK FOOTER //
// ./src/components/side-menu/sideMenuItem.js